// components/OfflineOverlay.jsx
import React from "react";
import { MdOutlineSignalWifiConnectedNoInternet4 } from "react-icons/md";
import "../pages/styles/OfflineOverlay.css";

const OfflineOverlay = ({ onRetry }) => {
  return (
    <div className="offline-overlay" role="alert">
      <div className="offline-card">
        <div className="offline-iconWrap">
          <MdOutlineSignalWifiConnectedNoInternet4 size={65} className="offline-icon" />
        </div>

        <h2 className="offline-title">No Internet Connection</h2>

        <p className="offline-text">
          An internet error occurred. Please check your connection and try again.
        </p>

        <button className="offline-btn" onClick={onRetry} aria-label="Retry connection">
          Try Again
        </button>
      </div>
    </div>
  );
};

export default OfflineOverlay;
